const Languages = {
  English: 'en',
  French: 'fr',
  Chinese: 'zh',
};
const LanguageValues = Object.values(Languages);

const PersonStatus = {
  Active: 'Active',
  Inactive: 'Inactive',
};
const PersonStatusValues = Object.values(PersonStatus);

const OrganizationType = {
  Admin: 'Admin',
  School: 'School',
  Vendor: 'Vendor',
};
const OrganizationTypeValues = Object.values(OrganizationType);

const OrgRoles = {
  SiteAdmin: 'Site-Admin',
  PACExecutive: 'PAC-Executive',
  HotLunchCoordinator: 'Hot-Lunch-Coordinator',
  Teacher: 'Teacher',
  Caregiver: 'Caregiver',
  Student: 'Student',
};
const OrgRolesValues = Object.values(OrgRoles);

const AllergenTag = {
  Peanut: 'peanut',
  TreeNut: 'tree-nut',
  Shellfish: 'shellfish',
  Dairy: 'dairy',
  Gluten: 'gluten',
  Egg: 'egg',
  Soy: 'soy',
  Sesame: 'sesame',
  Other: 'other',
};
const AllergenTagValues = Object.values(AllergenTag);

const DietaryTag = {
  Halal: 'halal',
  Vegetarian: 'vegetarian',
  Vegan: 'vegan',
  DairyFree: 'dairy-free',
  GlutenFree: 'gluten-free',
};
const DietaryTagValues = Object.values(DietaryTag);

const HotLunchCutoffType = {
  DaysBefore: 'days_before',
  DayOfWeek: 'day_of_week',
  ExplicitDatetime: 'explicit_datetime',
};
const HotLunchCutoffTypeValues = Object.values(HotLunchCutoffType);

const HotLunchDayStatus = {
  Draft: 'draft',
  Published: 'published',
  Closed: 'closed',
  Cancelled: 'cancelled',
};
const HotLunchDayStatusValues = Object.values(HotLunchDayStatus);

const HotLunchOrderStatus = {
  Draft: 'draft',
  PendingPayment: 'pending_payment',
  Paid: 'paid',
  Cancelled: 'cancelled',
  Refunded: 'refunded',
  Expired: 'expired',
};
const HotLunchOrderStatusValues = Object.values(HotLunchOrderStatus);

const HotLunchPaymentTender = {
  Stripe: 'stripe',
  Cash: 'cash',
  Cheque: 'cheque',
  Credit: 'credit',
};
const HotLunchPaymentTenderValues = Object.values(HotLunchPaymentTender);

const HotLunchPaymentStatus = {
  Pending: 'pending',
  Succeeded: 'succeeded',
  Failed: 'failed',
  Refunded: 'refunded',
};
const HotLunchPaymentStatusValues = Object.values(HotLunchPaymentStatus);

const HotLunchAudienceType = {
  WholeSchool: 'whole_school',
  Classrooms: 'classrooms',
};
const HotLunchAudienceTypeValues = Object.values(HotLunchAudienceType);

const HotLunchRefundPreference = {
  Card: 'card',
  Credit: 'credit',
};
const HotLunchRefundPreferenceValues = Object.values(HotLunchRefundPreference);

const StripeConnectStatus = {
  NotStarted: 'not_started',
  Pending: 'pending',
  Complete: 'complete',
  Restricted: 'restricted',
};
const StripeConnectStatusValues = Object.values(StripeConnectStatus);

const OrgMembershipStatus = {
  Active: 'active',
  Inactive: 'inactive',
  Revoked: 'revoked',
};
const OrgMembershipStatusValues = Object.values(OrgMembershipStatus);

const SubscriptionStatus = {
  Active: 'active',
  Comped: 'comped',
  NeedsPayment: 'needs_payment',
  PastDue: 'past_due',
};
const SubscriptionStatusValues = Object.values(SubscriptionStatus);

const BillingModel = {
  Manual: 'manual',
  CheckoutAnnual: 'checkout_annual',
};
const BillingModelValues = Object.values(BillingModel);

const InviteIntent = {
  Owner: 'owner',
  Member: 'member',
};
const InviteIntentValues = Object.values(InviteIntent);

const SchoolYearStatus = {
  Active: 'active',
  Disabled: 'disabled',
  Archived: 'archived',
};
const SchoolYearStatusValues = Object.values(SchoolYearStatus);

const CaregiverRelationship = {
  Primary: 'primary',
  Secondary: 'secondary',
};
const CaregiverRelationshipValues = Object.values(CaregiverRelationship);

const EventLocationMode = {
  InPerson: 'in_person',
  Virtual: 'virtual',
  Hybrid: 'hybrid',
};
const EventLocationModeValues = Object.values(EventLocationMode);

const EventCapability = {
  Calendar: 'calendar',
  Volunteers: 'volunteers',
  Documents: 'documents',
};
const EventCapabilityValues = Object.values(EventCapability);

const EventSource = {
  PacExecutive: 'pac_executive',
  System: 'system',
};
const EventSourceValues = Object.values(EventSource);

const VolunteerSignupStatus = {
  Confirmed: 'confirmed',
  Waitlisted: 'waitlisted',
  Cancelled: 'cancelled',
};
const VolunteerSignupStatusValues = Object.values(VolunteerSignupStatus);

const MessageAudienceType = {
  OrgAll: 'org_all',
  PlatformPacExecutives: 'platform_pac_executives',
};
const MessageAudienceTypeValues = Object.values(MessageAudienceType);

const PacDocumentType = {
  Agenda: 'agenda',
  Minutes: 'minutes',
  Upload: 'upload',
};
const PacDocumentTypeValues = Object.values(PacDocumentType);

const PacDocumentStatus = {
  Draft: 'draft',
  Final: 'final',
};
const PacDocumentStatusValues = Object.values(PacDocumentStatus);

const PacAgendaSectionKind = {
  Welcome: 'welcome',
  ApproveAgenda: 'approve_agenda',
  Guest: 'guest',
  Minutes: 'minutes',
  Correspondence: 'correspondence',
  Reports: 'reports',
  Unfinished: 'unfinished',
  NewBusiness: 'new_business',
  NextMeeting: 'next_meeting',
  NextAgendaItems: 'next_agenda_items',
  Adjournment: 'adjournment',
  Custom: 'custom',
};
const PacAgendaSectionKindValues = Object.values(PacAgendaSectionKind);

const AuditAction = {
  ResourceCreate: 'resource.create',
  ResourceUpdate: 'resource.update',
  ResourceDelete: 'resource.delete',
  EventPublish: 'event.publish',
  EventUnpublish: 'event.unpublish',
  MessageCreate: 'message.create',
  MessageUpdate: 'message.update',
  MessagePublish: 'message.publish',
  MessageUnpublish: 'message.unpublish',
  MessageDelete: 'message.delete',
  MessageEmailSend: 'message.email_send',
  EmailTemplateUpdate: 'email.template_update',
  SchoolRegistrationCodeRegenerate: 'school.registration_code.regenerate',
  RoleAssign: 'role.assign',
  RoleRevoke: 'role.revoke',
  MemberInvite: 'member.invite',
  OwnerTransfer: 'owner.transfer',
  BillingComp: 'billing.comp',
  BillingManualPayment: 'billing.manual_payment',
  BillingCheckout: 'billing.checkout',
  AuthLoginSuccess: 'auth.login.success',
  AuthLogout: 'auth.logout',
  AuthPasswordResetComplete: 'auth.password_reset.complete',
  SessionRevoke: 'session.revoke',
  PersonRegister: 'person.register',
  PersonEmailChange: 'person.email_change',
  TrackedLinkCreate: 'tracked_link.create',
  TrackedLinkRevoke: 'tracked_link.revoke',
  SchoolYearEnable: 'school_year.enable',
  SchoolYearDisable: 'school_year.disable',
  SchoolYearArchive: 'school_year.archive',
  SchoolYearPrepare: 'school_year.prepare',
  HotLunchCutoffOverride: 'hot_lunch.cutoff_override',
  HotLunchRefund: 'hot_lunch.refund',
  HotLunchManualOrder: 'hot_lunch.manual_order',
  HotLunchDayPublish: 'hot_lunch.day_publish',
  HotLunchDayUnpublish: 'hot_lunch.day_unpublish',
  HotLunchDayCancel: 'hot_lunch.day_cancel',
};
const AuditActionValues = Object.values(AuditAction);

export {
  AllergenTag,
  AllergenTagValues,
  AuditAction,
  AuditActionValues,
  BillingModel,
  BillingModelValues,
  CaregiverRelationship,
  CaregiverRelationshipValues,
  DietaryTag,
  DietaryTagValues,
  EventCapability,
  EventCapabilityValues,
  EventLocationMode,
  EventLocationModeValues,
  EventSource,
  EventSourceValues,
  HotLunchAudienceType,
  HotLunchAudienceTypeValues,
  HotLunchCutoffType,
  HotLunchCutoffTypeValues,
  HotLunchDayStatus,
  HotLunchDayStatusValues,
  HotLunchOrderStatus,
  HotLunchOrderStatusValues,
  HotLunchPaymentStatus,
  HotLunchPaymentStatusValues,
  HotLunchPaymentTender,
  HotLunchPaymentTenderValues,
  HotLunchRefundPreference,
  HotLunchRefundPreferenceValues,
  InviteIntent,
  InviteIntentValues,
  Languages,
  LanguageValues,
  MessageAudienceType,
  MessageAudienceTypeValues,
  OrganizationType,
  OrganizationTypeValues,
  OrgMembershipStatus,
  OrgMembershipStatusValues,
  OrgRoles,
  OrgRolesValues,
  PacAgendaSectionKind,
  PacAgendaSectionKindValues,
  PacDocumentStatus,
  PacDocumentStatusValues,
  PacDocumentType,
  PacDocumentTypeValues,
  PersonStatus,
  PersonStatusValues,
  SchoolYearStatus,
  SchoolYearStatusValues,
  StripeConnectStatus,
  StripeConnectStatusValues,
  SubscriptionStatus,
  SubscriptionStatusValues,
  VolunteerSignupStatus,
  VolunteerSignupStatusValues,
};
